import gql from 'graphql-tag';

const TOGGLE_VENUE_TRANSACTION_FLOW_BY_MERCHANT = gql`
  mutation toggleVenueTransactionFlowByMerchant(
    $params: ToggleVenueTransactionInput!
  ) {
    toggleVenueTransactionFlowByMerchant(params: $params) {
      venuesWhichAreNotActivatable
      venuesWhichWereAlreadyInTargetState
      venuesWhichWereUpdated
      venuesWhichHadAnErrorDuringUpdate
    }
  }
`;

export default TOGGLE_VENUE_TRANSACTION_FLOW_BY_MERCHANT;
